import { Link } from 'react-router-dom-v5-compat';
import { Tooltip } from 'src/components/atoms';
import { textStyleCss } from 'src/theme/atlas';
import { NavbarVariantEnum } from 'src/types';
import styled from 'styled-components';
import type { DefaultTheme } from 'styled-components';

const getVariantStyles = (theme: DefaultTheme) => ({
  reporter: {
    color: theme.isVaultVariant
      ? theme.newPalette.neutral.N900
      : theme.atlas.semantic.color.type.default,
    hoverColor: theme.isVaultVariant
      ? theme.newPalette.neutral.N900
      : theme.atlas.semantic.color.type.default,
    backgroundHoverColor: theme.isVaultVariant
      ? theme.newPalette.neutral.N200
      : theme.atlas.semantic.color.surface.variant,
    backgroundActiveColor: theme.isVaultVariant
      ? theme.newPalette.neutral.N300
      : theme.atlas.semantic.color.outline.fixed,
    selectionIndicator: theme.isVaultVariant
      ? theme.newPalette.turquoise.T300
      : theme.atlas.semantic.color.action.secondaryInverse.selectionIndicator,
  },
  manager: {
    color: theme.isVaultVariant
      ? theme.newPalette.neutral.N0
      : theme.atlas.semantic.color.action.secondaryInverse.onSecondaryInverse,
    hoverColor: theme.isVaultVariant
      ? theme.newPalette.neutral.N0
      : theme.atlas.semantic.color.action.secondaryInverse.onSecondaryInverse,
    backgroundHoverColor: theme.isVaultVariant
      ? theme.newPalette.neutral.N900
      : theme.atlas.semantic.color.action.secondaryInverse.hover,
    backgroundActiveColor: theme.isVaultVariant
      ? theme.newPalette.neutral.N900
      : 'transparent',
    selectionIndicator: theme.isVaultVariant
      ? theme.newPalette.turquoise.T300
      : theme.atlas.semantic.color.action.secondaryInverse.selectionIndicator,
  },
  public: {
    color: theme.isVaultVariant
      ? theme.newPalette.neutral.N800
      : theme.atlas.semantic.color.type.default,
    hoverColor: theme.isVaultVariant
      ? theme.newPalette.neutral.N800
      : theme.atlas.semantic.color.type.default,
    backgroundHoverColor: theme.isVaultVariant
      ? theme.newPalette.neutral.N200
      : theme.atlas.semantic.color.surface.variant,
    backgroundActiveColor: theme.isVaultVariant
      ? theme.newPalette.neutral.N300
      : theme.atlas.semantic.color.outline.fixed,
    selectionIndicator: theme.isVaultVariant
      ? theme.newPalette.turquoise.T300
      : theme.atlas.semantic.color.action.secondaryInverse.selectionIndicator,
  },
});

export const StyledLink = styled(Link)<{
  variant:
    | NavbarVariantEnum.REPORTER
    | NavbarVariantEnum.MANAGER
    | NavbarVariantEnum.PUBLIC;
  $isActive: boolean;
}>`
  padding: 12px 16px;
  width: 100%;
  display: flex;
  position: relative;
  box-sizing: border-box;
  text-align: left;
  align-items: center;
  justify-content: start;
  text-decoration: none;
  color: ${(props) => getVariantStyles(props.theme)[props.variant].color};
  height: 100%;
  ${({ theme }) =>
    theme.isVaultVariant
      ? `font-size: 14px; font-family: ${theme.typography.fontFamily}; font-weight: 400;`
      : textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  /* Preserve original navbar density: bodySmall token resolves to 24px
   * line-height in vault, which makes admin dropdowns tall enough that the
   * last link gets covered by Bottom's 54px gradient overlay. The old
   * navbar used line-height: 1.5 (21px on 14px font). */
  line-height: 1.5;
  background-color: ${(props) =>
    props.$isActive
      ? getVariantStyles(props.theme)[props.variant].backgroundActiveColor
      : 'transparent'};
  border-left: ${(props) =>
    props.theme.isVaultVariant
      ? 'none'
      : props.$isActive
        ? `3px solid ${getVariantStyles(props.theme)[props.variant].selectionIndicator}`
        : '3px solid transparent'};
  &:hover {
    color: ${(props) =>
      getVariantStyles(props.theme)[props.variant].hoverColor};
    background-color: ${(props) =>
      getVariantStyles(props.theme)[props.variant].backgroundHoverColor};
  }
  &:focus {
    background-color: ${(props) =>
      getVariantStyles(props.theme)[props.variant].backgroundActiveColor};
  }
`;
export const StyledText = styled.p<{ $navOpen?: boolean }>`
  display: flex;
  justify-content: start;
  overflow: hidden;
  white-space: nowrap;
  opacity: ${(props) => (props.$navOpen ? '1' : '0')};
  width: ${(props) => (props.$navOpen ? '100%' : '0%')};
  transition: all 0.36s;
  margin: 4px;
`;

export const StyledTooltip = styled(Tooltip)`
  margin-left: 14px;
`;
